import { gql } from '@apollo/client';

export const VERIFY_EMAIL_MUTATION = gql`
  mutation VerifyEmailMutation($token: String!) {
    verifyEmail(token: $token) {
      ... on SignInSuccess {
        viewer {
          user {
            email
            id
            slug
            role
          }
        }
      }
      ... on ValidationError {
        errors {
          error
          path
        }
      }
    }
  }
`;
